// extracted by mini-css-extract-plugin
module.exports = {"block":"_18623","group":"_5072","title":"_13408","list":"_18280","item":"_8396","name":"_14953","count":"_1373","price":"_587","dash":"_6575","highlight":"_18695"};